import deleteButton from '../assets/images/new-dashboard/delete.svg';
import editButton from '../assets/images/new-dashboard/edit.svg';
import plusImage from '../assets/images/new-dashboard/plus-with-fill.svg';
import eyeOpen from '../assets/images/eyeOpen.svg';

export const Icons = { deleteButton, editButton, plusImage, eyeOpen };
